import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

import { Box, styled, Typography as MuiTypography } from '@mui/material';

import { ChangePasswordFormContainer } from 'Auth/ChangePasswordPage/ChangePasswordFormContainer';
import { logout } from 'Auth/data';
import { UserAvatar } from 'Common/UserAvatar';
import { AvatarConsts } from 'Common/UserAvatar/Avatar/Avatar.consts';
import { ActionPosition } from 'Components';
import { urls } from 'Router';
import { useAppDispatch } from 'Store';
import { Colors } from 'Themes/colors';
import { Spacing } from 'Themes/spacing';
import { useSelectCurrentUserInfo, useSelectUserDisplayName } from 'User/data';
import { useBoolean } from 'Utils/customHooks';

import { AccountCircleIcon, LockIcon, LogoutIcon } from '@libs/shared/ui/icons';
import { BaseModal } from '@/libs/shared/ui';

import { MyAccountFormContainer } from './MyAccountFormContainer';
import { MyAccountModal } from './MyAccountModal';
import { StyledWrapper } from './UserProfileModal.styles';

const Options = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: ${Spacing.small};
`;

const Container = styled(Box)`
  position: relative;
`;

const TypographyDisplayName = styled(MuiTypography)`
  text-wrap: nowrap;
`;

export const UserProfileModal = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [menuIsDisplayed, showMenu, hideMenu] = useBoolean();
  const [myAccountDisplayed, displayMyAccount, hideMyAccount] = useBoolean();
  const [changePasswordDisplayed, displayChangePassword, hideChangePassword] = useBoolean();

  const currentUserInfo = useSelectCurrentUserInfo();
  const currentUserInfoDisplayName = useSelectUserDisplayName() ?? AvatarConsts.fallbackUserName;

  const handleLogoutClick = () => {
    dispatch(logout());
  };

  const handleDisplayMyAccount = () => {
    hideMenu();
    displayMyAccount();
  };

  const handleDisplayChangePassword = () => {
    hideMenu();
    displayChangePassword();
  };

  const handleNavigateToHealthStatus = () => {
    hideMenu();
    navigate(urls.healthStatusPage);
  };

  return (
    <Container>
      <StyledWrapper onClick={showMenu}>
        <TypographyDisplayName>{currentUserInfoDisplayName}</TypographyDisplayName>
        <UserAvatar
          displayName={currentUserInfoDisplayName}
          color={currentUserInfo.avatarColor || ''} // TODO: default color?
          avatarUrl={currentUserInfo.avatar}
        />
      </StyledWrapper>

      {menuIsDisplayed && (
        <>
          <BaseModal open={true} onClose={hideMenu} variant="dropdown">
            <Options>
              <ActionPosition
                icon={<AccountCircleIcon style={{ color: Colors.green }} />}
                text={t('userMenu.myAccount')}
                onClick={handleDisplayMyAccount}
              />
              <ActionPosition
                icon={<LockIcon style={{ color: Colors.green }} />}
                text={t('userMenu.changePassword')}
                onClick={handleDisplayChangePassword}
              />
              {/* <ActionPosition
                icon={<HealthAndSafetyIcon style={{ color: Colors.green }} />}
                text={t('userMenu.healthStatus')}
                onClick={handleNavigateToHealthStatus}
              /> */}
              <ActionPosition
                icon={<LogoutIcon style={{ color: Colors.green }} />}
                text={t('userMenu.logOut')}
                onClick={handleLogoutClick}
              />
            </Options>
          </BaseModal>
        </>
      )}

      {myAccountDisplayed && (
        <MyAccountModal open={myAccountDisplayed} onClose={hideMyAccount}>
          <MyAccountFormContainer onClose={hideMyAccount} />
        </MyAccountModal>
      )}

      {changePasswordDisplayed && (
        <BaseModal
          open={true}
          onClose={hideChangePassword}
          title={t('userMenu.changePassword')}
          variant="positioned"
          maxWidth="600px"
        >
          <ChangePasswordFormContainer onClose={hideChangePassword} />
        </BaseModal>
      )}
    </Container>
  );
};
